export default "<p>bhp-data-grid works!</p>\n";